export default "__VITE_ASSET__DCyigUM8__"